import {jQuery as $, lodash as _} from 'lib/shim';

import {generateObjectFitCallback} from 'util/objectfit';
import {waitForRepaint} from 'util/dom';



const NAME = 'molecule-header-image',
	SELECTOR = '.'+NAME;


class MoleculeHeaderImage {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$image = this._$element.find('picture > img');

			this._objectFitCallbackName = null;

			this._prime();
			$element.dataDuo('primed-ready', true);
		}

		return $element;
	}



	_prime() {
		let _this_ = this;

		this._objectFitCallbackName = generateObjectFitCallback({
			callbackHandler : function(cb){
				cb();
				return _this_._app.registerFuzzyUpdateLoopCallback(NAME+'-'+_this_._id, cb);
			},
			$element : this._$image,
			containerSelector : 'figure',
			position : {
				'top' : '50%',
				'left' : '50%'
			}
		});
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new MoleculeHeaderImage(app, $this));
	});

	return $elements;
}
